
import Input from '../../shared/input';
import Icon from '../../../../icon';
import { IconType, IconProperty } from '../../../../icon/enums';
import { StyleSizeType } from '../../../../../styles/enums';
import {
  InputProperty,
  InputEventType,
  InputType,
  InputSlotType,
} from '../../shared/input/enums';
import PhoneInputProps from './mixins/PhoneInputProps';
import { PhoneInputProperty } from './enums';
import { ControlEventType } from '../../enums';
import { NOT_NUMBER_REGEXP } from './constants';
import PhoneInputFormatService from './services/PhoneInputFormatService';

export default {
  name: 'PhoneInput',
  components: {
    Input,
    Icon,
  },
  mixins: [PhoneInputProps],
  data() {
    return {
      InputProperty,
      InputEventType,
      InputType,
      InputSlotType,
      PhoneInputProperty,
      IconType,
      IconProperty,
      StyleSizeType,
    };
  },
  computed: {
    displayValue() {
      const value = this[PhoneInputProperty.Value];

      if (value) {
        return this.getDisplayValue(value.toString());
      }

      return null;
    },
    valueLength() {
      return this[PhoneInputProperty.Mask].replace(NOT_NUMBER_REGEXP, '').length;
    },
  },
  methods: {
    getDisplayValue(value) {
      return PhoneInputFormatService.getDisplayPhoneNumber(value, this[PhoneInputProperty.Mask]);
    },
    getValueFromDisplayValue(value) {
      return value.replace(NOT_NUMBER_REGEXP, '').slice(0, this.valueLength);
    },
    handleInput(event) {
      const value = this.getValueFromDisplayValue(event.target.value);

      // eslint-disable-next-line
      event.target.value = this.getDisplayValue(value);

      if (value !== this[PhoneInputProperty.Value]) {
        this.$emit(ControlEventType.Change, value);
      }
    },
    handleInputFocus(event) {
      this.$emit(ControlEventType.Focus, this.getValueFromDisplayValue(event.target.value));
    },
    handleInputBlur(event) {
      this.$emit(ControlEventType.Blur, this.getValueFromDisplayValue(event.target.value));
    },
  },
};
